import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	infoFieldContainer: {
		flex: 1,
		minWidth: 0,
	},
	infoFieldLabel: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		marginBottom: THEME.spacing.xs,
	},
	infoFieldValue: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		wordBreak: 'break-word',
		overflowWrap: 'break-word',
	},
	businessInfoGrid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(5, 1fr)',
		gap: THEME.spacing.md,
		marginBottom: THEME.spacing.md,
	},
	fullWidthSection: {
		gridColumn: '1 / -1',
	},
	descriptionValue: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		whiteSpace: 'pre-line',
	},
});
